<mat-toolbar>
  Camiones
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)="newCamion()"><mat-icon color="primary">add_circle_outline</mat-icon> Añadir camión</button>
    <button mat-menu-item (click)="saveExcel()"><mat-icon color="primary">description</mat-icon> Exportar tabla</button>
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='tableHeader'>
    <mat-form-field  class='buscarInput searchMobile'>
      <mat-label>Buscar</mat-label>
      <input matInput type="text" [(ngModel)]="filter" placeholder="" (keyup)="applyFilter($event)">
    </mat-form-field>
    <mat-form-field class="searchMobile">
      <mat-label>Estado</mat-label>
      <mat-select [(value)]="estado" (selectionChange)="getCamiones()">
        <mat-option value="all">Todos</mat-option>
        <mat-option value="true">Activo</mat-option>
        <mat-option value="false">Inactivo</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class='tableBlock'>
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef > </th>
        <td mat-cell *matCellDef="let element" class='miniCell'>
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon matTooltip="Acciones">more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editarCamion(element.id)">
              <mat-icon color="primary">create</mat-icon>
              <span>Modificar</span>
            </button>
            <button mat-menu-item (click)="deleteCamion(element.id)">
              <mat-icon color="primary">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <ng-container matColumnDef="marca">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Marca </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.marca}} </td>
      </ng-container>
      <ng-container matColumnDef="modelo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Modelo </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.modelo}} </td>
      </ng-container>
      <ng-container matColumnDef="matricula">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class='minWidth'> Matricula </th>
        <td mat-cell *matCellDef="let element" class='minWidth'> {{element.matricula}} </td>
      </ng-container>
      <ng-container matColumnDef="activo">
        <th mat-header-cell *matHeaderCellDef class='minWidth'> Activo </th>
        <td mat-cell *matCellDef="let element" class='minWidth'>
          @if (element.activo === 'true') {
            <mat-icon class='green' matTooltip="Camión activo">fiber_manual_record</mat-icon>
          }
          @if (element.activo === 'false') {
            <mat-icon class='red' matTooltip="Camión inactivo">fiber_manual_record</mat-icon>
          }
        </td>
      </ng-container>

      <tr class="mat-row" *matNoDataRow>
        <td class="emptyCell" colspan="5">No existen camiones...<br> <button mat-stroked-button (click)="newCamion()">Crear camión</button></td>
      </tr>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator [pageSize]="25" [pageSizeOptions]="pages" showFirstLastButtons></mat-paginator>
</div>
